import { render, staticRenderFns } from "./stocklock.vue?vue&type=template&id=c12da3f8"
import script from "./stocklock.vue?vue&type=script&lang=js"
export * from "./stocklock.vue?vue&type=script&lang=js"
import style0 from "./stocklock.vue?vue&type=style&index=0&id=c12da3f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports